export enum OnbarodQuestionType {
  TEXT = "TEXT",
  MULTILINE_TEXT="MULTILINE_TEXT",
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
}

export enum OnboardAnswerOptionType{
  RADIO_BUTTON = "RADIO_BUTTON",
  TEXT_BOX = "TEXT_BOX"
}

export interface IOnboardAnswerOption{
  value:string;
  type?:OnboardAnswerOptionType;
}

export interface IOnboardQuestion {
  id: number;
  type: OnbarodQuestionType;
  question: string;
  subQuestion?:string;
  options?: IOnboardAnswerOption[];
  isMandatory?:boolean;
  fieldName?:string;
  order?:number;
}

const companyOnboardingQuestions: IOnboardQuestion[] = [
  { id: 1, fieldName: "companyName", type: OnbarodQuestionType.TEXT, question: "Get started with your company name", isMandatory: true },
  { id: 2,fieldName: "websiteUrl", type: OnbarodQuestionType.TEXT, question: "Enter your Website URL" },
  {
    id: 3,
    fieldName: "businessSize",
    type: OnbarodQuestionType.SINGLE,
    subQuestion:"What's your business size ?",
    question: "How many full-time team members are on your team?",
    options: [{value:"Just me and a few others (1-10)"}, {value:"A growing team (11-50)"}, {value:"A bustling team (51-250)"}, {value:"Larger team (251+)"}],
  },
  {
    id: 4,
    fieldName: "businessDetails",
    type: OnbarodQuestionType.SINGLE,
    subQuestion: "What industry best describes your business ?",
    question: "Every business has its strengths! Which industry or niche do you operate in?",
    options: [{value:"Retail (Fashion, Electronics, etc.)"}, {value:"Manufacturing (Consumer Goods, Machinery, etc.)"}, {value:"Technology (SaaS, Hardware, etc.)"},{value:"Healthcare (Medical Devices, Services, etc.)"},{value:"Services (Consulting, Financial, etc.)"},{value: "", type: OnboardAnswerOptionType.TEXT_BOX}],
  },
  {
    id: 5,
    fieldName: "services",
    type: OnbarodQuestionType.MULTILINE_TEXT,
    subQuestion: "What Are Your Main Products or Services?",
    question: "What products or services keep your customers coming back?",
  },
  {
    id:6,
    fieldName: "mainCustomers",
    type: OnbarodQuestionType.SINGLE,
    subQuestion:"Who Are Your Main Customers?",
    question: "Who do you serve the most?",
    options: [{value:"Other businesses (B2B)"},{value: "Individual consumers (B2C)"}, {value:"A mix of both"},{value: "", type: OnboardAnswerOptionType.TEXT_BOX}],
  },
  {
    id: 7,
    type: OnbarodQuestionType.SINGLE,
    fieldName: "revenueSource",
    subQuestion:"How Does Your Business Generate Revenue?",
    question: "What are your primary sources of revenue?",
    options: [{value:"Selling products"}, {value:"Providing services"}, {value:"Subscription-based revenue"}, {value:"Advertising"},{value: "", type: OnboardAnswerOptionType.TEXT_BOX}],
  },
  {
    id: 8,
    fieldName: "TechInBusiness",
    subQuestion: "How Do You Use Technology in Your Business?",
    type: OnbarodQuestionType.MULTILINE_TEXT,
    question: "How do you leverage technology to support and grow your business?",
  },
  {
    id: 9,
    fieldName: "BusinessChallenges",
    type: OnbarodQuestionType.SINGLE,
    subQuestion:"What Are Your Biggest Challenges Right Now?",
    question: "What are the top three challenges your business is currently facing?",
    options: [{value:"Finding and retaining customers"}, {value:"Competing with other businesses"}, {value:"Managing supply chain issues"}, {value:"Navigating regulations"}, {value:"Implementing new technology"}, {value:"Accessing reliable market data"},{value: "", type: OnboardAnswerOptionType.TEXT_BOX}],
  },
  {
    id: 10,
    fieldName: "BusinessChallengesInWords",
    subQuestion: "Your Main Challenge in Your Own Words ?",
    type: OnbarodQuestionType.MULTILINE_TEXT,
    question: "What’s the biggest challenge that keeps you up at night? Feel free to share an example or a brief story",
  },
  {
    id: 11,
    fieldName: "Vision",
    subQuestion: "Your Vision for the Future",
    type: OnbarodQuestionType.MULTILINE_TEXT,
    question: "Fast forward five years… What’s your big dream for your business, and what type of help would you need to achieve it?",
  },
];

export default companyOnboardingQuestions;
